import { fetchWithAuth } from '../api';
import { POST_METHOD, PARTNER_UPLOAD_ANON_DATA_URL } from '../config';
import { UploadAnonDataPayload } from '../types';

type UploadAnonDataResponse = {
  upload_id: string;
};

type UploadAnonDataType = (
  partnerToken: string,
  companyData: UploadAnonDataPayload,
) => Promise<UploadAnonDataResponse | null>;
type UploadAnonDataListPayload = UploadAnonDataPayload[];

export const uploadAnonData: UploadAnonDataType = async (partnerToken, companyData) => {
  const companyDataList = [companyData];

  return await fetchWithAuth<UploadAnonDataListPayload, UploadAnonDataResponse>(
    PARTNER_UPLOAD_ANON_DATA_URL,
    companyDataList,
    partnerToken,
    POST_METHOD,
  );
};
